<div class="oiq-ui-dialog w-[480px]">
  <header>
    <div class="__title flex items-center justify-between">
      <h2>Connect Gmail via IMAP</h2>
      <button class="oiq-button oiq-button--link __close" type="button" (click)="cancel()">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>

  <main class="space-y-4">
    <p class="text-sm text-gray-500">
      Enter your Gmail address and an app password to connect via IMAP/SMTP.
    </p>

    <form [formGroup]="form" class="flex flex-col gap-4">
      <oiq-form-input
        label="Email"
        placeholder="user@gmail.com"
        formControlName="email"
        type="email">
      </oiq-form-input>

      <!-- Hidden input for browser autofill -->
      <input type="password" autocomplete="current-password" class="hidden" />

      <oiq-form-password
        label="App Password"
        placeholder="Enter your app password"
        formControlName="password">
      </oiq-form-password>
    </form>

    @if (errorMessage()) {
      <p class="text-sm text-red-500">{{ errorMessage() }}</p>
    }

    <p class="text-xs text-gray-400">
      You need to generate an app password in your Google Account settings.
      <a
        href="https://myaccount.google.com/apppasswords"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary underline">
        Create an app password
      </a>
    </p>
  </main>

  <footer>
    <div class="__left"></div>
    <div class="__right">
      <button class="oiq-button oiq-button--outline" type="button" (click)="cancel()">
        Cancel
      </button>
      <button
        class="oiq-button oiq-button--primary--solid"
        type="button"
        [disabled]="isSubmitting()"
        (click)="submit()">
        @if (isSubmitting()) {
          Connecting...
        } @else {
          Connect
        }
      </button>
    </div>
  </footer>
</div>
